import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Header, LeftSideItem, AddNewSectionModal, LeftSideTab, LeftSideItemSortableItem, HeaderAddAndReorderButton, ConfirmationModal } from 'admin/views/site-designer/modules';
import { MENU_SEGMENT_KEY, SECTION_SEGMENT_KEY, GLOBA_SEGMENT_KEY, PAGE_SEGMENT_KEY, addOrRemoveQueryParams, getComponents, COMING_SOON_SETTINGS } from 'admin/views/site-designer/data';
import AccessSettings from './access';
import Button from 'common/components/elements/buttons/primary';
import cx from 'classnames';
import CreatePage from 'admin/views/site-designer/modules/create-page';

import SectionComponent from 'admin/views/site-designer/modules/sections';
import { arrayMoveImmutable } from 'array-move';
import PageLoader from 'common/components/modules/page-loading'

import { WrraperFrame, SectionFrame, RightChekComponent, GoToGlobalSettingsButton } from 'admin/views/site-designer/modules/sections/modules';
import {
   sortableContainer,
} from 'react-sortable-hoc';

import { updatePageSectionsOrder } from 'admin/state/modules/site-designer/actions';

import { useDispatch } from 'react-redux';

const SortableContainer = sortableContainer(({ children }) => {
   return <>{children}</>;
});

const SiteDesignerLeftSide = ({
   currentSegment,
   isFullScreen,
   states,
   list,
   isPrepearComponentForRender,
   onChangeSegment,
   goToBack,
   isMobile,
   screenWidth,
   onChangeSection,
   currentSectionsData,
   onReorderPages,
   onReorderSections,
   deletePage,
   toggleVisibilityPage,
   restorePage,
   fetching,
   currentPage,
   onSaveDraft,
   onChangeData,
   fetchSaveAsDraft,
   addNewSection,
   deleteSection,
   restoreSection,
   toggleVisibilitySection,
   reservPageSections,
   onPrepearComponentForRender,
   onAddNewPage,
   onSelectGlobalSettings,
}) => {
   const dispatch = useDispatch()
   const sectionComponents = getComponents();
   const [activeTab, setActiveTab] = useState('design');
   const [openAddSection, setOpenAddSection] = useState(false);
   const [openReorderState, setOpenReorderState] = useState({
      isOpen: false,
      list: [],
      orderedData: [],
   });

   const [changeCollactionConfirmModal, setChangeCollactionConfirmModal] = useState({
      isOpen: false,
      args: [],
   })


   const getActiveTab = () => {
      if(currentSegment.show_left_side_tab){
         return activeTab;
      }
      return 'design';
   }
   // Get section COMPONENTS list
   const getSectionComponents = (type) => {
      if(SECTION_SEGMENT_KEY === currentSegment?.type && currentSegment?.section_type) {
         return sectionComponents?.[currentSegment.section_type];
      }
      return null;
   }
   // Get section COMPONENT characters limit
   const getComponentLimit = (component, limits) => {
      const componentName = component?.name;
      let limit = limits?.[componentName];
      if(!limit){
         limit = component?.limit || component?.inputProps?.limit;
      }
      return limit;
   }
   const components = getSectionComponents();
   const getDatTooltipContent = (item) => {
      if(Boolean(item.is_deleted)){
         return  'Clicking ‘Save and publish’ will permanently delete this page'
      }
      if(item.is_home_page){
         return 'This page cannot be deleted as it serves as your landing page';
      }
      if(item.is_system){
         return 'This section cannot be edited';
      }

      return null;
   }
   const genearteOrder = () => {
      let order = {}

      Object.keys(reservPageSections).forEach(uuid => {
         order = {
            ...order,
            [uuid]: reservPageSections[uuid].order,
         }
      });
      return order
   }
   const onSortEnd = ({ oldIndex, newIndex }) => {
      const newData = arrayMoveImmutable(list, oldIndex, newIndex)
      if(oldIndex !== newIndex){
         let asd = {}
         const orderedData = newData.map((item, index) => {
            asd = {
               ...asd,
               [item.uuid]: index + 1,
            }
            return {
               id: item.id,
               order: index + 1,
            };
         });
         setOpenReorderState({
            ...openReorderState,
            list: newData,
            orderedData: orderedData,
         });
         if(PAGE_SEGMENT_KEY === currentSegment?.type){
            if(onPrepearComponentForRender){
               onPrepearComponentForRender(false, true)
            }
            dispatch(updatePageSectionsOrder(asd))
         }
      }

   };
   ////////////////////////////////

   const onClickBack = () => {
      setOpenReorderState({
         isOpen: false,
         list: [],
         orderedData: [],
      });
      goToBack(currentSegment.type)
   };


   const sectionsOrPageActions = (pageAction, sectionAction) => {
      if(currentSegment.type === PAGE_SEGMENT_KEY && currentPage?.uuid){
         if(sectionAction){
            sectionAction();
            return;
         }
      }
      if(currentSegment.type === MENU_SEGMENT_KEY){
         if(pageAction){
            pageAction();
            return;
         }
      }
   }

   return (
      <>
         {
            changeCollactionConfirmModal?.isOpen && (
               <ConfirmationModal
                  title='Discard collections?'
                  description='Discard collections'
                  buttonText='Yes'
                  icon='cancel'
                  iconColor='error'
                  onClose={ _ => {
                     setChangeCollactionConfirmModal({
                        isOpen: false,
                        args: [],
                     })
                  } }
                  action={ () => {
                     const args = changeCollactionConfirmModal.args
                     setChangeCollactionConfirmModal({
                        isOpen: false,
                        args: [],
                     })
                     onChangeSection(...args);
                  } }
               />
            )
         }
         {
            openAddSection && (
               <AddNewSectionModal
                  isMobile={ isMobile }
                  states={ states }
                  onClose={ () => setOpenAddSection(false) }
                  addNewSection={ (type, isGlobalSettings) => {
                     addNewSection(type, isGlobalSettings, (callback) => {
                        if(callback){
                           callback()
                        }
                        setOpenAddSection(false)
                     })
                     if(!isGlobalSettings){
                        setOpenAddSection(false)
                     }
                  } }
                  currentPage={ currentPage }
               />
            )
         }
         <div
            className={ cx({
               'bg-panel border border-divider h-full w-[375px] overflow-y-auto ams-custom-scrool p-4 gap-6 flex flex-col site-builder-transition z-[9]': true,
               'site-designer-hide-left-seciotn': isFullScreen,
               'site-designer-show-left-seciotn': !isFullScreen,
            }) }
         >
            <Header
               title={ currentSegment.name }
               description={ currentSegment.description }
               type={ currentSegment.type }
               onSetStep={ () => {} }
               goToBack={ onClickBack }
               onSaveDraft={ onSaveDraft }
               stepActiveState={ {} }
               disabledSaveAsDraft={ fetchSaveAsDraft }
            />

            <div
               className={ cx({
                  'flex flex-col w-full items-start gap-4': true,
                  'flex-1': fetching,
               }) }
            >
               {
                  fetching && (
                     <PageLoader
                        width={ 48 }
                        gifWrapperClassName='m-auto'
                     />
                  )
               }
               {
                  !fetching && (
                     <>
                        {
                           currentSegment.show_left_side_tab && (
                              <LeftSideTab
                                 activeTab={ activeTab }
                                 onClick={ tab => setActiveTab(tab) }
                              />
                           )
                        }
                        {
                           getActiveTab() === 'design' && (
                              <>
                                 {
                                    currentSegment.show_create_or_edit_page_name_input && (
                                       <CreatePage
                                          id={ 'new_page' === currentSegment.type ? 'new_page' : currentPage.id }
                                          selectedPage={ currentPage }
                                          onChange={ (name, value) => {
                                             onChangeData({
                                                [name]: value,
                                             })
                                          } }
                                       />
                                    )
                                 }
                                 {
                                    currentSegment.show_add_and_reorder_button && (
                                       <HeaderAddAndReorderButton
                                          addButtonText={ currentSegment.add_new_button_text }
                                          isOpenReorder={ openReorderState?.isOpen }
                                          disabledDoneButton={ !openReorderState?.orderedData?.length  }
                                          onClickReorder={ _ => {
                                             setOpenReorderState({
                                                isOpen: true,
                                                list: list,
                                                orderedData: [],
                                             });
                                          } }
                                          onClickDone={ _ => {
                                             setOpenReorderState({
                                                isOpen: false,
                                                list: [],
                                                orderedData: [],
                                             });
                                             sectionsOrPageActions(
                                                () => onReorderPages(openReorderState.orderedData, openReorderState.list),
                                                () => onReorderSections(currentPage.uuid, openReorderState.orderedData, openReorderState.list)
                                             )
                                          } }
                                          onClickCancel={ _ => {
                                             setOpenReorderState({
                                                isOpen: false,
                                                list: [],
                                                orderedData: [],
                                             });
                                             if(PAGE_SEGMENT_KEY === currentSegment?.type){
                                                if(onPrepearComponentForRender){
                                                   onPrepearComponentForRender(false, true)
                                                }
                                                dispatch(updatePageSectionsOrder(genearteOrder()))
                                             }

                                          } }
                                          onClickAddNew={ _ =>  {
                                             if(currentSegment.type === MENU_SEGMENT_KEY){
                                                onAddNewPage()
                                                return;
                                             }
                                             setOpenAddSection(true);
                                          } }
                                          showAddButton={ Boolean(currentSegment?.show_add_section_button) }
                                       />
                                    )
                                 }
                                 {
                                    currentSegment?.type !== SECTION_SEGMENT_KEY && Boolean(list?.length) && (
                                       <div className='flex flex-col w-full gap-2'>
                                          <>
                                             {
                                                openReorderState?.isOpen && (
                                                   <SortableContainer
                                                      onSortEnd={ onSortEnd }
                                                      axis='y'
                                                      useDragHandle
                                                      helperClass='sortable-helper'
                                                   >
                                                      <div className='flex flex-col w-full gap-2'>
                                                         {
                                                            openReorderState.list.map((item, index) => {
                                                               if(item.is_home_page){
                                                                  return (
                                                                     <LeftSideItem
                                                                        itemIndex={ item.id || index }
                                                                        key={ `item-${ item.id }` }
                                                                        item={ item }
                                                                        showDragIcon
                                                                        dataTooltipContent='This page cannot be reordered as it serves as your landing page'
                                                                     />
                                                                  )
                                                               }
                                                               return (
                                                                  <LeftSideItemSortableItem
                                                                     onSortEnd={ onSortEnd }
                                                                     index={ index }
                                                                     reorder={ item }
                                                                     key={ `item-${ item.id }` }
                                                                     shouldUseDragHandle={ true }
                                                                     itemIndex={ item.id || index }
                                                                  />
                                                               )
                                                            })
                                                         }
                                                      </div>
                                                   </SortableContainer>

                                                )
                                             }
                                             {
                                                !openReorderState?.isOpen && list.map((item, index) => {
                                                   return (
                                                      <LeftSideItem
                                                         key={ item.id || index.toString() }
                                                         onClickDelete={ (callback) => {
                                                            sectionsOrPageActions(
                                                               () => deletePage(item.id, callback),
                                                               () => deleteSection(currentPage.uuid, item.id, callback, item.uuid)
                                                            )
                                                         } }
                                                         onToggleVisibility={ (callback) => {
                                                            sectionsOrPageActions(
                                                               () => toggleVisibilityPage(item.id, callback),
                                                               () => toggleVisibilitySection(currentPage.uuid, item.id, callback, item.uuid)
                                                            )
                                                         } }
                                                         onRestore={ (callback) => {
                                                            sectionsOrPageActions(
                                                               () => restorePage(item.id, callback),
                                                               () => restoreSection(currentPage.uuid, item.id, callback, item.uuid)
                                                            )
                                                         } }
                                                         isDeleted={ Boolean(item.is_deleted) }
                                                         itemIndex={ item.id || index }
                                                         leftSideType={ currentSegment.type === GLOBA_SEGMENT_KEY ? GLOBA_SEGMENT_KEY : currentSegment.list_item_navigate }
                                                         onClick={ () => {
                                                            onChangeSegment(item, currentSegment.list_item_navigate)
                                                         } }
                                                         dataTooltipContent={ getDatTooltipContent(item) }
                                                         canUpdateOnlyVisibility={ 'livestream' === item.slug }
                                                         item={ item }
                                                      />
                                                   )
                                                })
                                             }
                                             {
                                                currentSegment?.type === MENU_SEGMENT_KEY && (
                                                   <LeftSideItem
                                                      item={ { ...COMING_SOON_SETTINGS, is_active: true } }
                                                      showDragIcon={ openReorderState?.isOpen }
                                                      dataTooltipContent='This page cannot be reordered'
                                                      onClick={ _ => onSelectGlobalSettings(COMING_SOON_SETTINGS) }
                                                      itemIndex={ COMING_SOON_SETTINGS.uuid }
                                                   />
                                                )
                                             }
                                          </>
                                       </div>
                                    )
                                 }
                                 {
                                    Boolean(currentSegment?.show_global_settings_section) && (
                                       <div className='border border-divider rounded-lg w-full'>
                                          <LeftSideItem
                                             leftSideType={ GLOBA_SEGMENT_KEY }
                                             onClick={ () => {
                                                setOpenReorderState({
                                                   isOpen: false,
                                                   list: [],
                                                   orderedData: [],
                                                });
                                                onChangeSegment(states[GLOBA_SEGMENT_KEY], GLOBA_SEGMENT_KEY)
                                             } }
                                             itemIndex='global'
                                             item={ states[GLOBA_SEGMENT_KEY] }
                                          />
                                       </div>
                                    )
                                 }
                                 {/* Start Render Page Section (or Global Setting Section) Components */}
                                 {
                                    Boolean(components) && (
                                       <div className='flex flex-col gap-4 w-full'>
                                          {
                                             Object.keys(components).map((item, index) => {
                                                const sectionComponent = components[item];
                                                if(sectionComponent?.type === 'span'){
                                                   return (
                                                      <span className='text-major font-bold text-sl leading-[24px]'>{sectionComponent.text}</span>
                                                   )
                                                }
                                                return (
                                                   <WrraperFrame
                                                      key={ index.toString() }
                                                      isHasBg={ 'social_media_links' !== currentSegment.uuid }
                                                   >
                                                      {
                                                         sectionComponent.map((component, index) => {
                                                            if(component?.type === 'span'){
                                                               return (
                                                                  <span className='text-major font-bold text-sl leading-[24px]'>{component.text}</span>

                                                               )
                                                            }
                                                            const { name, rightComponent } = component;
                                                            let payload = currentSectionsData?.[currentSegment.uuid];

                                                            const rightComponentName = component?.rightComponentName || name;
                                                            if(component?.meta){
                                                               payload = payload?.metas || {};
                                                            }
                                                            let componentValue = payload?.[name];
                                                            if(['content_cards', 'social_media_links'].includes(currentSegment.uuid)){
                                                               componentValue = payload;
                                                            }
                                                            if(['color'].includes(currentSegment.uuid)){
                                                               if(name === 'site-colors'){
                                                                  componentValue = payload;
                                                               }
                                                               if(name === 'color_background'){
                                                                  componentValue = payload[name]?.color;
                                                               }
                                                            }
                                                            let rightComponentValue = payload?.[rightComponentName]
                                                            if('object' === typeof componentValue){
                                                               rightComponentValue = componentValue?.[rightComponentName];
                                                            }
                                                            if(component?.nested_type && componentValue?.[component.nested_type]){
                                                               componentValue = componentValue[component.nested_type]
                                                            }

                                                            // if(!payload || !(payload && name in payload)){
                                                            //    return (
                                                            //       <span key={ index.toString() }>
                                                            //          ---
                                                            //       </span>
                                                            //    )
                                                            // }
                                                            return (
                                                               <SectionFrame
                                                                  key={ index.toString() }
                                                                  title={ component.title }
                                                                  description={ component.description }
                                                                  isOptional={ component.isOptional }
                                                                  isPanelBg={ component.isPanelBg }
                                                                  type={ component.type }
                                                                  rightComponent={
                                                                     !rightComponent ? null : (
                                                                        <RightChekComponent
                                                                           checked={ rightComponentValue }
                                                                           rightComponent={ rightComponent }
                                                                           onChange={ (_, value) => {
                                                                              let updateName = rightComponentName;
                                                                              let updateValue = value;
                                                                              if('object' === typeof  payload?.[name]){
                                                                                 updateName = name;
                                                                                 updateValue = {
                                                                                    ...payload?.[name],
                                                                                    [rightComponentName]: value,
                                                                                 }
                                                                              }
                                                                              onChangeSection(updateName, updateValue, Boolean(component?.meta))
                                                                           } }
                                                                           name={ `${ currentSegment.section_type }_${ rightComponentName }` }
                                                                        />
                                                                     )
                                                                  }
                                                               >
                                                                  {
                                                                     (!rightComponent || (rightComponent && rightComponentValue)) && (
                                                                        <>
                                                                           {
                                                                              component?.type && (
                                                                                 <SectionComponent
                                                                                    component={ component }
                                                                                    type={ component.type }
                                                                                    fullSrc={ payload?.['image_full_src'] }
                                                                                    limit={ getComponentLimit(component, currentSegment.component_limit) }
                                                                                    value={ componentValue }
                                                                                    onChange={ (name, value, otherValue = {}) => {
                                                                                       let updateValue = value;
                                                                                       if(component?.nested_type){
                                                                                          updateValue = {
                                                                                             ...payload?.[name],
                                                                                             [component.nested_type]: value,
                                                                                          }
                                                                                       }
                                                                                       if(['color'].includes(currentSegment.uuid)){
                                                                                          if(name === 'color_background'){
                                                                                             updateValue = {
                                                                                                ...payload[component.name],
                                                                                                color: value,
                                                                                             }
                                                                                          }
                                                                                       }

                                                                                       if(component?.isContentShowcaseTypeOption){
                                                                                          // const collactionsData = currentSectionsData?.[currentSegment.uuid]?.metas?.collections;
                                                                                          setChangeCollactionConfirmModal({
                                                                                             isOpen: true,
                                                                                             args: [name, updateValue, Boolean(component?.meta), otherValue],
                                                                                          })
                                                                                          return
                                                                                       }
                                                                                       onChangeSection(name, updateValue, Boolean(component?.meta), otherValue)
                                                                                    } }
                                                                                    sectionName={ currentSegment.section_type  }
                                                                                    isPrepearComponentForRender={ isPrepearComponentForRender }
                                                                                 />
                                                                              )
                                                                           }
                                                                           {
                                                                              component?.go_to_link && (
                                                                                 <GoToGlobalSettingsButton
                                                                                    state={ component.go_to_link }
                                                                                    onChangeSegment={ (item, type) => onChangeSegment(item, type) }
                                                                                 />
                                                                              )
                                                                           }
                                                                        </>
                                                                     )
                                                                  }
                                                               </SectionFrame>
                                                            )
                                                         })
                                                      }
                                                   </WrraperFrame>
                                                )
                                             })
                                          }
                                       </div>
                                    )
                                 }
                                 {/* End Render Page Section (or Global Setting Section) Components */}
                                 {
                                    currentSegment?.go_to_link && (
                                       <GoToGlobalSettingsButton
                                          state={ currentSegment.go_to_link }
                                          onChangeSegment={ (item, type) => onChangeSegment(item, type) }
                                       />
                                    )
                                 }
                                 {
                                    currentSegment?.show_delete_section_button && (
                                       <div className='mx-auto h-9 items-center mt-2'>
                                          <Button
                                             text='Delete this section'
                                             textSize='small'
                                             secondIconName='delete'
                                             textColor='error'
                                             fontIconColor='error'
                                             backgroundColor='transparent'
                                             textPosition='left'
                                             padding='none'
                                             onClick={ () => {
                                                deleteSection(currentPage.uuid, currentSegment.id, () => {
                                                   onChangeSegment({ ...states[PAGE_SEGMENT_KEY], ...currentPage }, PAGE_SEGMENT_KEY)
                                                   addOrRemoveQueryParams(SECTION_SEGMENT_KEY);
                                                }, currentSegment.uuid)
                                             } }
                                             classNames='h-full'
                                             textMarginExistSecondIcon='0'
                                          />
                                       </div>
                                    )
                                 }

                              </>
                           )
                        }
                        {
                           getActiveTab() === 'access_settings' && (

                              <AccessSettings
                                 access={ currentPage }
                                 isHomepage={ currentPage.is_home_page }
                                 screenWidth={ screenWidth }
                                 membersStatistics={ currentPage.member_statistics }
                                 handleAccsessChange={ (data, callback) => {
                                    onChangeData(data);
                                    if(callback){
                                       callback();
                                    }
                                 } }
                                 isAutoSave
                              />
                           )
                        }
                     </>
                  )
               }
            </div>
         </div>
      </>
   )
}

SiteDesignerLeftSide.propTypes = {
   currentSegment: PropTypes.object,
   list: PropTypes.array,
   states: PropTypes.object,
   isFullScreen: PropTypes.bool,
   isPrepearComponentForRender: PropTypes.bool,
   isMobile: PropTypes.bool,
   onChangeSegment: PropTypes.func,
   onChangeSection: PropTypes.func,
   onReorderPages: PropTypes.func,
   restoreSection: PropTypes.func,
   onSaveDraft: PropTypes.func,
   deletePage: PropTypes.func,
   onChangeData: PropTypes.func,
   onReorderSections: PropTypes.func,
   toggleVisibilityPage: PropTypes.func,
   restorePage: PropTypes.func,
   deleteSection: PropTypes.func,
   goToBack: PropTypes.func,
   screenWidth: PropTypes.number,
   currentSectionsData: PropTypes.object,
   fetching: PropTypes.bool,
   addNewSection: PropTypes.func,
   toggleVisibilitySection: PropTypes.func,
   currentPage: PropTypes.object,
   fetchSaveAsDraft: PropTypes.bool,
   onPrepearComponentForRender: PropTypes.func,
   onAddNewPage: PropTypes.func,
   reservPageSections: PropTypes.object,
   onSelectGlobalSettings: PropTypes.func,
}

export default SiteDesignerLeftSide;
